import { _ } from '../../../lib';
export const emptyAgentThreadContent = () => ({
    content: [],
    pendingChanges: [],
    pendingQuestions: [],
    completions: [],
});
export const joinAgentThread = (summary, content) => ({
    ...summary,
    ...(content ?? emptyAgentThreadContent()),
    pendingChanges: content
        ? reconcileThreadPendingChanges(summary, content)
        : summary.pendingChanges,
});
export const joinAgentThreads = (summaries, content) => _.mapValues(summaries, (summary, threadID) => joinAgentThread(summary, content[threadID]));
const reconcileThreadPendingChanges = (summary, content) => {
    const contentNonPendingChanges = content.pendingChanges.filter(change => change.status != null && change.status !== 'pending');
    const pendingChanges = summary.pendingChangesCount > 0 ? summary.pendingChanges : [];
    return _.chain([...contentNonPendingChanges, ...pendingChanges])
        .uniqBy(change => change.id)
        .value();
};
export const buildQuestionAnswersMessageText = (answers) => {
    const stripLiteralBrackets = (value) => value.replace(/[\[\]]/g, '').trim();
    const body = answers
        .map(answer => `Q: ${stripLiteralBrackets(answer.questionText)}\nA: ${stripLiteralBrackets(answer.answerText)}`)
        .join('\n\n');
    return `Answered from question tool:\n\n${body}`;
};
export const hasPendingApproval = (threads, approvalID) => _.some(threads, thread => thread.pendingChanges?.some(change => change.id === approvalID) ?? false);
export const getPendingChangeStatus = (change) => {
    if (change.status === 'executing') {
        return 'executing';
    }
    if (change.status === 'approved') {
        return 'approved';
    }
    if (change.status === 'rejected') {
        return 'rejected';
    }
    if (change.status === 'error') {
        return 'error';
    }
    return 'pending';
};
//# sourceMappingURL=agent-thread-helpers.js.map